import React, { useEffect, useState } from "react";
import { Shell } from "./components/layout/Shell";
import { HeroSection } from "./components/sections/HeroSection";
import { AboutSection } from "./components/sections/AboutSection";
import { WorkSection } from "./components/sections/WorkSection";
import { ArcadeSection } from "./components/sections/ArcadeSection";
import { ContactSection } from "./components/sections/ContactSection";

export const App: React.FC = () => {
  const [theme, setTheme] = useState<"dark" | "light">(() => {
    if (typeof window !== "undefined") {
      const saved = localStorage.getItem("theme");
      if (saved === "light" || saved === "dark") return saved;
    }
    return "dark";
  });

  useEffect(() => {
    const el = document.documentElement;
    if (theme === "light") {
      el.classList.add("light");
      el.classList.remove("dark");
      el.setAttribute("data-theme", "light");
    } else {
      el.classList.add("dark");
      el.classList.remove("light");
      el.setAttribute("data-theme", "dark");
    }
    localStorage.setItem("theme", theme);
  }, [theme]);

  const handleToggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <Shell theme={theme} onToggleTheme={handleToggleTheme}>
      <HeroSection />
      <AboutSection />
      <WorkSection />
      <ArcadeSection />
      <ContactSection />
    </Shell>
  );
};

export default App;
